import { RouterProvider } from 'react-router-dom'
import { router } from '@/app/router'
import ErrorBoundary from '@/shared/components/feedback/ErrorBoundary'
import ServerStatusIndicator from '@/shared/components/ui/ServerStatusIndicator'

export default function App() {
  return (
    <ErrorBoundary>
      <RouterProvider router={router} />
      <ServerStatusIndicator autoCheck checkInterval={30_000} />
    </ErrorBoundary>
  )
}
